import { render, staticRenderFns } from "./mutasi_objek_pajak_wajib_pajak.vue?vue&type=template&id=562eefd4&"
import script from "./mutasi_objek_pajak_wajib_pajak.vue?vue&type=script&lang=js&"
export * from "./mutasi_objek_pajak_wajib_pajak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports